/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import _map from 'lodash/map';
import { Recruiter } from '../../../../../firebase/firestore/documents/recruiter';
import { useCurrentUserProfile } from '../../../../../app/hooks/useCurrentUserProfile';
import { useStoreActions } from '../../../../../models/hooks';
import { RecruiterT } from '../../../../calendar/types';

const useRecruiter = (): Recruiter[] => {
  const { currentUserProfile } = useCurrentUserProfile();
  const accountId = currentUserProfile?.account ?? '';
  const fetchAllRecruiters = useStoreActions((state) => state.calendar.fetchAllRecruiters);
  const [recruiters, setRecruiters] = React.useState<RecruiterT[]>([]);

  React.useEffect(() => {
    if (accountId) {
      fetchAllRecruiters({ accountId }).then((res) => {
        setRecruiters(res.data.data);
      });
    }
    // eslint-disable-next-line
  }, [accountId]);

  return React.useMemo(
    () => {
      if (recruiters && currentUserProfile && accountId) {
        // const filteredRecruiters = recruiters.filter((r) => r.anonymousUser !== true && r.firstName !== 'anonymous');
        return _map(recruiters, (r) => {
          return r as Recruiter;
        });
      }
      return [];
    },
    // eslint-disable-next-line
    [recruiters],
  );
};

export default useRecruiter;
